/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProductionOrder } from './APIProductionOrder';
import {
    APIProductionOrderFromJSON,
    APIProductionOrderFromJSONTyped,
    APIProductionOrderToJSON,
} from './APIProductionOrder';

/**
 * 
 * @export
 * @interface APIPaginatedProductionOrderList
 */
export interface APIPaginatedProductionOrderList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedProductionOrderList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedProductionOrderList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedProductionOrderList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIProductionOrder>}
     * @memberof APIPaginatedProductionOrderList
     */
    results: Array<APIProductionOrder>;
}

/**
 * Check if a given object implements the APIPaginatedProductionOrderList interface.
 */
export function instanceOfAPIPaginatedProductionOrderList(value: object): value is APIPaginatedProductionOrderList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedProductionOrderListFromJSON(json: any): APIPaginatedProductionOrderList {
    return APIPaginatedProductionOrderListFromJSONTyped(json, false);
}

export function APIPaginatedProductionOrderListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedProductionOrderList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIProductionOrderFromJSON)),
    };
}

export function APIPaginatedProductionOrderListToJSON(value?: APIPaginatedProductionOrderList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIProductionOrderToJSON)),
    };
}

